import { render, staticRenderFns } from "./admin-operators.vue?vue&type=template&id=20fdb276&lang=pug&"
import script from "./admin-operators.vue?vue&type=script&lang=js&"
export * from "./admin-operators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports